import { RouteProtectedElement } from '@components'

import { ReactElement } from 'react'
import { matchPath, useLocation } from 'react-router'

import { Scope } from '../../enums/scope'
import { SalesReport } from './SalesReport'

interface SalesReportRouteProps {
  paths: string[]
}

export const SalesReportRoute = ({ paths }: SalesReportRouteProps): ReactElement | null => {
  const { pathname } = useLocation()
  const matchedPath = paths.find((path) => matchPath(path, pathname))

  if (!matchedPath) {
    return null
  }

  return (
    <RouteProtectedElement scopes={Scope.ReportsInvoicing}>
      <SalesReport />
    </RouteProtectedElement>
  )
}
